import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { SectionWrapper } from "../../../../UI/SectionWrapper/SectionWrapper";
import ShakaPlayer from "@client/components/CustomerPortal/components/ShakaPlayer";
import { CMSAsset } from "@client/models/CMS/cmsAsset";

interface IMediaAccordionProps {
  asset: CMSAsset;
}

const MediaAccordion: React.FC<IMediaAccordionProps> = ({ asset }) => {
  const getMediaResourseDASHUrl = asset?.medias?.[0]?.mediaResources.find(
    (media) => media.protocol === "dash"
  )?.url;

  if (!getMediaResourseDASHUrl) return null;

  return (
    <SectionWrapper>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          className="accordion-summary-gray"
        >
          Media Preview
        </AccordionSummary>
        <AccordionDetails>
          <Grid container>
            <Grid item xs={6}>
              <ShakaPlayer
                style={{ width: "100%" }}
                controls
                autoPlay={false}
                src={getMediaResourseDASHUrl}
              />
            </Grid>
            <Grid item xs={6} />
          </Grid>
        </AccordionDetails>
      </Accordion>
    </SectionWrapper>
  );
};

export default MediaAccordion;
